// extracted by mini-css-extract-plugin
export default {"recos":"_1-z","productCardOverride":"a2-z","rowHasBadge":"b2-z"};